export default __webpack_public_path__ + "static/media/coin_xau.3cd7a050.svg";